import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'turtle',
      d: 'M-2,-3.5h1v0.5h-1zM-2,-3h2v0.5h-2zM1.5,-3h1v0.5h-1zM-2,-2.5h1v0.5h-1zM0.5,-2.5h2v0.5h-2zM-3.5,-2h1v0.5h-1zM-2,-2h0.5v0.5h-0.5zM0.5,-2h1v0.5h-1zM-3.5,-1.5h1.5v0.5h-1.5zM0.5,-1.5h1.5v0.5h-1.5zM-3.5,-1h2.5v0.5h-2.5zM-0.5,-1h2.5v0.5h-2.5zM2.5,-1h0.5v1h-0.5zM-3,-0.5h1v0.5h-1zM-1.5,-0.5h2.5v0.5h-2.5zM-2,0h1v0.5h-1zM1.5,0h1v1h-1zM-2,0.5h1.5v0.5h-1.5zM-2,1h1v0.5h-1z',
    },
    {
      paint: 'pine',
      d: 'M0,-3h1v0.5h-1zM0,-2.5h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v1h-0.5zM-1,-1h0.5v0.5h-0.5zM-2,-0.5h0.5v0.5h-0.5zM1,-0.5h1.5v0.5h-1.5zM-1,0h2.5v0.5h-2.5z',
    },
    { paint: 'moss', d: 'M-1,-2.5h1v0.5h-1zM-1.5,-2h2v0.5h-2zM-2,-1.5h2v0.5h-2z' },
  ],
  pixels: 82,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
